import React from "react"

import moment from "moment-timezone"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { PAYER_STATUS_CONFIG } from "../../config/payerStatus.config"

export const PayerStatusUpdatedComponent: React.FunctionComponent<
    IPayerStatusUpdatedComponentProps
> = props => {
    // Fetched by server, browser clock can be a bit behind it, so time isn't shown as future
    const fetchedAt = moment.min(moment(props.fetchedAt), moment())

    // Label with color of the dot next to it
    const [label, color] = props.isLoading
        ? ["Updating…", NIRVANA_COLORS.brand.warmShadow]
        : props.isStale
          ? [`Last updated ${fetchedAt.fromNow()}`, NIRVANA_COLORS.brand.orange]
          : [
                `Updated ${fetchedAt.format(PAYER_STATUS_CONFIG.timeFormat)} (${fetchedAt.fromNow()})`,
                NIRVANA_COLORS.brand.green,
            ]

    return (
        <div aria-live="polite" className="flex items-center gap-[8px]">
            <span
                className="h-[8px] w-[8px] rounded-full"
                style={{ backgroundColor: color }}
            />

            <PrimaryText typography="textSmall" className="opacity-60">
                {label}
            </PrimaryText>
        </div>
    )
}

interface IPayerStatusUpdatedComponentProps {
    fetchedAt: number
    isLoading: boolean // refresh the customer asked for
    isStale: boolean
}
